import { ExtendedAreaModels, findApartmentBuilding, isApartment } from '@bpd-library/utilities';

import {
    createApartmentBuildingPolygon,
    createConstructionNumberPolygon,
    createPolygonMarker,
} from './service';

const extendApiModelsWithWishlist = (data: ExtendedAreaModels): ExtendedAreaModels => {
    const drawnApartmentBuildingIds: string[] = [];

    data.constructionNumbers.forEach(constructionNumber => {
        if (!isApartment({ constructionNumber })) {
            const marker = createPolygonMarker(constructionNumber);
            const polygon = createConstructionNumberPolygon(constructionNumber);

            constructionNumber.mapDataItems = [];

            if (marker) constructionNumber.mapDataItems.push(marker);
            if (polygon) constructionNumber.mapDataItems.push(polygon);
        } else {
            const { apartmentBuilding } = constructionNumber;

            if (apartmentBuilding && !drawnApartmentBuildingIds.includes(apartmentBuilding.id))
                drawnApartmentBuildingIds.push(apartmentBuilding.id);
        }
    });

    drawnApartmentBuildingIds.forEach(apartmentBuildingId => {
        const apartmentBuilding = findApartmentBuilding(data.apartmentBuildings, {
            id: apartmentBuildingId,
        });

        if (apartmentBuilding) {
            const marker = createPolygonMarker(apartmentBuilding);
            const polygon = createApartmentBuildingPolygon(apartmentBuilding);

            apartmentBuilding.mapDataItems = [];

            if (marker) apartmentBuilding.mapDataItems.push(marker);
            if (polygon) apartmentBuilding.mapDataItems.push(polygon);
        }
    });

    return data;
};

export { extendApiModelsWithWishlist };
